<template>
  <section
    :id="id"
    :style="dark ? 'background-color: #eee;' : ''"
    class="extra"
  >
    <v-container grid-list-xl>
      <v-layout
        row
        wrap
        align-center
        py-9
        px-sm-7
        v-bind:class="{ superheader: superheader }"
      >
        <v-flex md12 v-if="h0" class="text-center extra-header">{{
          h0
        }}</v-flex>
        <v-flex
          v-if="imagePresent()"
          md6
          sm10
          offset-sm-1
          offset-md-0
          :class="right ? 'order-md5' : ''"
        >
          <slot name="image"></slot>
          <div class="extra-image-wrapper">
            <img v-if="image" :src="src(image)" class="extra-image" />
            <img v-if="spark" :src="src(spark)" class="extra-spark" />
            <v-parallax
              v-if="sparkle"
              :src="src(sparkle)"
              class="extra-sparkle"
            />
          </div>
          <div v-if="overlay" class="extra-image-wrapper">
            <img v-if="overlay" :src="src(overlay)" class="extra-overlay" />
          </div>
          <div
            v-if="ipadh"
            :style="{
              backgroundImage: `url('${src(ipadh)}')`,
            }"
            class="extra-ipadh"
          >
            <img src="/img/ipadh.png" />
          </div>
          <div
            v-if="imac"
            :style="{
              backgroundImage: `url('${src(imac)}')`,
            }"
            class="extra-imac"
          >
            <img src="/img/imac.png" />
          </div>
          <div
            v-if="iphone"
            :style="{ backgroundImage: `url('${src(iphone)}')` }"
            class="extra-iphone"
          >
            <img src="/img/iphone.png" />
          </div>
        </v-flex>

        <v-flex :md6="imagePresent()" offset-md-0 sm10 offset-sm-1 pl-md-12>
          <!-- The slot is not shown, it's used only to take preformatted content and feed it into markdown tag. -->
          <slot v-if="false"></slot>

          <slot name="ru" v-if="$i18n.locale === 'ru'"></slot>
          <slot name="en" v-if="$i18n.locale === 'en'"></slot>
          <slot name="zh" v-if="$i18n.locale === 'zh'"></slot>

          <div ref="extra_text" class="extra-text" v-html="html"></div>

          <slot name="action">
            <v-flex
              mt-5
              v-if="html && html.length > 0"
              :class="imagePresent() ? '' : 'text-center'"
            >
              <v-btn :to="to" outlined color="primary">
                {{ $t(action) }}
                <v-icon>arrow_right</v-icon>
              </v-btn>
            </v-flex>
          </slot>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import Vue from "vue";
import { renderSlotForLocale, slotForLocale } from "../extra.js";

export default Vue.component("extra", {
  name: "extra",
  props: {
    id: String,
    image: String,
    ipad: String,
    ipadh: String,
    imac: String,
    iphone: String,
    iphoneh: String,
    sparkle: String,
    spark: String,
    overlay: String,
    action: { type: String, default: "submit_application" },
    to: { type: String, default: "demo_request" },
    dark: { type: Boolean, default: false },
    superheader: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
  },
  data() {
    return {
      h0: null,
      html: "",
    };
  },
  watch: {
    "$i18n.locale": function(locale) {
      this.renderContentsForLocale(locale);
    },
  },
  mounted() {
    this.renderContentsForLocale(this.$i18n.locale);
  },
  methods: {
    src(url) {
      if (url.startsWith("/")) return url;
      else return "/img/" + url;
    },
    h0ForLocale(locale) {
      var h0Tag =
        this.$slots[locale] &&
        this.$slots[locale].find((node) => {
          return node.tag === "h0";
        });
      if (h0Tag) return h0Tag.children[0].text;
      else {
        var slot = slotForLocale(this.$slots, locale);
        if (slot) return slot.data.attrs.h0;
        else return null;
      }
    },
    imagePresent() {
      return (
        this.image ||
        this.spark ||
        this.sparkle ||
        this.overlay ||
        this.ipad ||
        this.ipadh ||
        this.imac ||
        this.iphone ||
        this.$slots["image"]
      );
    },
    renderContentsForLocale(locale) {
      this.h0 = this.h0ForLocale(locale);
      this.$refs.extra_text = renderSlotForLocale(this.$slots, locale);
      this.html = renderSlotForLocale(this.$slots, locale);
    },
  },
});
</script>

<style>
.extra h0 {
  display: none;
}
.extra-header {
  font-size: 270%;
}
.extra-image {
  max-width: 100%;
}

.extra-text {
  margin-bottom: 1em;
}

.extra-text h1 {
  font-size: 180%;
  line-height: 1.1em;
  margin-bottom: 1em;
  font-weight: 300;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.layout.superheader {
  padding-top: 10em !important;
}

.superheader h1 {
  font-size: 270%;
  position: absolute;
  width: 100%;
  text-align: center;
  left: 0;
  padding: 0.5em 2em;
  margin-top: -3em;
}

.extra-text ul,
.extra-text p {
  color: #555;
}

.extra-text ul li {
  padding-bottom: 0.5em;
  line-height: 1.3em;
}

.extra-text code {
  box-shadow: none;
}

.extra-sparkle {
  max-width: 100%;
  padding-top: 100%;
  display: block;
  height: auto !important;

  /* Set clip path in percent, so it scales with the screen size */
  clip-path: polygon(
    50% 3.4%,
    53.206% 0%,
    55.95% 3.783%,
    59.562% 0.82%,
    61.802% 4.924%,
    65.764% 2.447%,
    67.459% 6.803%,
    71.706% 4.854%,
    72.831% 9.391%,
    77.291% 8.002%,
    77.827% 12.645%,
    82.43% 11.838%,
    82.366% 16.512%,
    87.033% 16.299%,
    86.374% 20.927%,
    91.029% 21.312%,
    89.785% 25.818%,
    94.354% 26.798%,
    92.542% 31.107%,
    96.948% 32.663%,
    94.602% 36.705%,
    98.771% 38.811%,
    95.928% 42.52%,
    99.795% 45.143%,
    96.501% 48.457%,
    100% 51.553%,
    96.311% 54.418%,
    99.385% 57.938%,
    95.357% 60.307%,
    97.959% 64.189%,
    93.662% 66.024%,
    95.745% 70.209%,
    91.249% 71.479%,
    92.779% 75.895%,
    88.158% 76.579%,
    89.111% 81.155%,
    84.441% 81.243%,
    84.803% 85.903%,
    80.158% 85.393%,
    79.921% 90.061%,
    75.381% 88.96%,
    74.549% 93.56%,
    70.188% 91.887%,
    68.773% 96.342%,
    64.66% 94.125%,
    62.689% 98.363%,
    58.895% 95.638%,
    56.396% 99.589%,
    52.98% 96.4%,
    50% 100%,
    47.02% 96.4%,
    43.603% 99.589%,
    41.106% 95.638%,
    37.312% 98.363%,
    35.34% 94.125%,
    31.228% 96.342%,
    29.814% 91.887%,
    25.451% 93.56%,
    24.62% 88.96%,
    20.079% 90.061%,
    19.842% 85.393%,
    15.198% 85.903%,
    15.56% 81.243%,
    10.889% 81.155%,
    11.843% 76.579%,
    7.221% 75.895%,
    8.752% 71.479%,
    4.256% 70.209%,
    6.339% 66.024%,
    2.042% 64.189%,
    4.643% 60.307%,
    0.616% 57.938%,
    3.691% 54.418%,
    0% 51.553%,
    3.5% 48.457%,
    0.205% 45.143%,
    4.072% 42.52%,
    1.229% 38.811%,
    5.399% 36.705%,
    3.053% 32.663%,
    7.458% 31.107%,
    5.647% 26.798%,
    10.216% 25.818%,
    8.97% 21.312%,
    13.626% 20.927%,
    12.967% 16.299%,
    17.635% 16.512%,
    17.572% 11.838%,
    22.174% 12.645%,
    22.709% 8.002%,
    27.17% 9.391%,
    28.295% 4.854%,
    32.541% 6.803%,
    34.236% 2.447%,
    38.199% 4.924%,
    40.438% 0.82%,
    44.051% 3.783%,
    46.795% 0%
  );
  display: block;
}

.extra-spark {
  width: 100%;
  clip-path: polygon(
    50% 3.4%,
    53.206% 0%,
    55.95% 3.783%,
    59.562% 0.82%,
    61.802% 4.924%,
    65.764% 2.447%,
    67.459% 6.803%,
    71.706% 4.854%,
    72.831% 9.391%,
    77.291% 8.002%,
    77.827% 12.645%,
    82.43% 11.838%,
    82.366% 16.512%,
    87.033% 16.299%,
    86.374% 20.927%,
    91.029% 21.312%,
    89.785% 25.818%,
    94.354% 26.798%,
    92.542% 31.107%,
    96.948% 32.663%,
    94.602% 36.705%,
    98.771% 38.811%,
    95.928% 42.52%,
    99.795% 45.143%,
    96.501% 48.457%,
    100% 51.553%,
    96.311% 54.418%,
    99.385% 57.938%,
    95.357% 60.307%,
    97.959% 64.189%,
    93.662% 66.024%,
    95.745% 70.209%,
    91.249% 71.479%,
    92.779% 75.895%,
    88.158% 76.579%,
    89.111% 81.155%,
    84.441% 81.243%,
    84.803% 85.903%,
    80.158% 85.393%,
    79.921% 90.061%,
    75.381% 88.96%,
    74.549% 93.56%,
    70.188% 91.887%,
    68.773% 96.342%,
    64.66% 94.125%,
    62.689% 98.363%,
    58.895% 95.638%,
    56.396% 99.589%,
    52.98% 96.4%,
    50% 100%,
    47.02% 96.4%,
    43.603% 99.589%,
    41.106% 95.638%,
    37.312% 98.363%,
    35.34% 94.125%,
    31.228% 96.342%,
    29.814% 91.887%,
    25.451% 93.56%,
    24.62% 88.96%,
    20.079% 90.061%,
    19.842% 85.393%,
    15.198% 85.903%,
    15.56% 81.243%,
    10.889% 81.155%,
    11.843% 76.579%,
    7.221% 75.895%,
    8.752% 71.479%,
    4.256% 70.209%,
    6.339% 66.024%,
    2.042% 64.189%,
    4.643% 60.307%,
    0.616% 57.938%,
    3.691% 54.418%,
    0% 51.553%,
    3.5% 48.457%,
    0.205% 45.143%,
    4.072% 42.52%,
    1.229% 38.811%,
    5.399% 36.705%,
    3.053% 32.663%,
    7.458% 31.107%,
    5.647% 26.798%,
    10.216% 25.818%,
    8.97% 21.312%,
    13.626% 20.927%,
    12.967% 16.299%,
    17.635% 16.512%,
    17.572% 11.838%,
    22.174% 12.645%,
    22.709% 8.002%,
    27.17% 9.391%,
    28.295% 4.854%,
    32.541% 6.803%,
    34.236% 2.447%,
    38.199% 4.924%,
    40.438% 0.82%,
    44.051% 3.783%,
    46.795% 0%
  );
}

.extra-overlay {
  max-width: 65%;
  max-height: 65%;
  position: relative;
  top: -250px;
  margin-bottom: -230px;
  right: -35%;
}

.extra-image-wrapper {
  filter: drop-shadow(1px 1px 4px rgba(0, 0, 0, 0.3));
}

/* iPad */
.extra-ipadh {
  background-size: cover;
  background-position: center 25% 25%;
  background-clip: content-box;

  border-radius: 5%;
  background-color: #fff;
}

.extra-ipadh img {
  width: 102%;
  position: relative;
  /* top: -2px; */
  display: block;
}

/* iMac */
.extra-imac {
  background-size: cover;
  background-position: center 35% 25%;
  background-clip: content-box;

  border-radius: 5%;
  background-color: #fff;
}

.extra-imac img {
  width: 102%;
  position: relative;
  display: block;
}

.extra-iphone {
  background-size: 70%;
  border-radius: 25px;
  background-position: 50px 15px;
}
.extra-iphone img {
  width: 50%;
}
</style>
